import { logoutHref } from "./api";
import { initials } from "./lib/apps";
import { el } from "./lib/dom";
import { pendingRequests } from "./session";
import type { WhoAmI } from "./types";

/** Platform chrome only — Bounteous brand + nav + user chip. No product shell. */
export function renderChrome(me: WhoAmI): HTMLElement {
  return el("header", { class: "topbar" }, [
    el("a", { href: "/", "data-link": "", class: "brand" }, [
      el("img", { class: "brand-mark", src: "/hub-mark.svg", alt: "", width: "28", height: "28" }),
      el("span", { class: "brand-word" }, ["Bounteous "]),
      el("span", { class: "brand-hub grad-text" }, ["Hub"]),
    ]),
    el("nav", { class: "nav" }, [
      el("a", { href: "/", "data-link": "", class: "nav-link" }, ["Apps"]),
      el("a", { href: "/feedback", "data-link": "", class: "nav-link" }, ["Give feedback"]),
      me.is_admin ? adminLink() : null,
    ]),
    el("div", { class: "user-chip" }, [
      el("span", { class: "avatar" }, [initials(me.name)]),
      el("span", { class: "user-name" }, [me.name]),
      el("a", { href: logoutHref(), class: "signout" }, ["Sign out"]),
    ]),
  ]);
}

/** Admin nav link with a live open-request count badge (from the session store). */
function adminLink(): HTMLElement {
  const link = el("a", { href: "/admin", "data-link": "", class: "nav-link" }, ["Admin"]);
  const count = pendingRequests.get();
  if (count > 0) link.append(badge(count));
  return link;
}

function badge(count: number): HTMLElement {
  return el(
    "span",
    { class: "nav-badge", title: `${count} open access request(s)` },
    [String(count)],
  );
}

/** Patch the already-rendered nav badge to the current store count (called after
 *  an admin approves/denies, so it ticks down without a page refresh). */
export function refreshPendingBadge(): void {
  const link = document.querySelector<HTMLAnchorElement>('.topbar .nav a[href="/admin"]');
  if (!link) return;
  const count = pendingRequests.get();
  const existing = link.querySelector<HTMLElement>(".nav-badge");
  if (count > 0) {
    if (existing) {
      existing.textContent = String(count);
      existing.title = `${count} open access request(s)`;
    } else {
      link.append(badge(count));
    }
  } else if (existing) {
    existing.remove();
  }
}
